
  export default {
    mounted() {
      this.chartData = JSON.parse(this.el.dataset.chartData || "[]")
      this.i18n = JSON.parse(this.el.dataset.i18n || "null") || window.I18n || {}
      this.smoothingMode = '7day'
      this.renderChart()

      // Listen for button clicks on the toggle
      const toggleContainer = document.getElementById('throughput-trend-smoothing')
      if (toggleContainer) {
        toggleContainer.addEventListener('click', (e) => {
          const btn = e.target.closest('.smoothing-btn')
          if (!btn) return

          // Update active state
          toggleContainer.querySelectorAll('.smoothing-btn').forEach(b => {
            b.classList.remove('bg-white', 'text-text-primary', 'font-semibold', 'shadow-[0px_2px_8px_0px_rgba(14,8,84,0.12)]')
            b.classList.add('text-text-secondary', 'font-normal')
          })
          btn.classList.remove('text-text-secondary', 'font-normal')
          btn.classList.add('bg-white', 'text-text-primary', 'font-semibold', 'shadow-[0px_2px_8px_0px_rgba(14,8,84,0.12)]')

          this.smoothingMode = btn.dataset.value
          this.renderChart()
        })
      }
    },

    calculateMovingAverage(data, windowSize) {
      return data.map((_, index, arr) => {
        const start = Math.max(0, index - windowSize + 1)
        const window = arr.slice(start, index + 1)
        const sum = window.reduce((acc, val) => acc + val, 0)
        return Math.round(sum / window.length)
      })
    },

    renderChart() {
      const chartData = this.chartData
      const i18n = this.i18n
      const t = (key) => i18n[key]
      if (chartData.length === 0) {
        this.el.innerHTML = `<div class="flex items-center justify-center h-full text-text-muted">${t("No throughput data available")}</div>`
        return
      }

      import("highcharts").then((Highcharts) => {
        const dates = chartData.map(d => d.date)
        const rawReceived = chartData.map(d => d.received)
        const rawShipped = chartData.map(d => d.shipped)

        let receivedData, shippedData
        switch (this.smoothingMode) {
          case 'daily':
            receivedData = rawReceived
            shippedData = rawShipped
            break
          case '28day':
            receivedData = this.calculateMovingAverage(rawReceived, 28)
            shippedData = this.calculateMovingAverage(rawShipped, 28)
            break
          case '7day':
          default:
            receivedData = this.calculateMovingAverage(rawReceived, 7)
            shippedData = this.calculateMovingAverage(rawShipped, 7)
            break
        }

        window.Enaia.applyHighchartsTheme(Highcharts.default)
        Highcharts.default.chart(this.el.id, {
          chart: {
            type: 'area',
            backgroundColor: 'transparent'
          },
          title: { text: null },
          xAxis: {
            categories: dates,
            labels: {
              rotation: -45,
              style: {
                fontSize: '10px',
                color: '#6B7280'
              },
              step: Math.ceil(dates.length / 10)
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: t("Units"),
              style: { fontSize: '12px' }
            }
          },
          legend: {
            enabled: true,
            align: 'center',
            verticalAlign: 'bottom'
          },
          tooltip: {
            shared: true,
            useHTML: true,
            formatter: function() {
              const date = this.x
              const received = this.points[0]?.y || 0
              const shipped = this.points[1]?.y || 0
              return `<div style="padding: 8px;">
                <strong>${date}</strong><br/>
                ${t("Received")}: ${received.toLocaleString()}<br/>
                ${t("Shipped")}: ${shipped.toLocaleString()}
              </div>`
            }
          },
          plotOptions: {
            area: {
              stacking: 'normal',
              lineWidth: 2,
              marker: { enabled: false },
              fillOpacity: 0.3
            }
          },
          series: [{
            name: t("Received"),
            data: receivedData,
            color: '#0086e6'
          }, {
            name: t("Shipped"),
            data: shippedData,
            color: '#F97316'
          }],
          credits: { enabled: false }
        })
      })
    }
  }
